import React, { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const PayableToField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    // Auto-populate with patient name if payableTo is empty
    useEffect(() => {
        if (currentRefund && !currentRefund.checkInfo?.payableTo) {
            const firstName = currentRefund.firstName?.trim() || '';
            const lastName = currentRefund.lastName?.trim() || '';
            
            if (firstName || lastName) {
                const patientName = `${firstName} ${lastName}`.trim();
                dispatch(updateCheckInfo({ payableTo: patientName }));
            }
        }
    }, [currentRefund?.firstName, currentRefund?.lastName, currentRefund?.checkInfo?.payableTo, dispatch]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ payableTo: event.target.value }));
    };

    return (
        <TextField
            label="Payable To"
            value={currentRefund?.checkInfo?.payableTo || ''}
            onChange={handleChange}
            size="small"
            fullWidth
            required
        />
    );
};

export default PayableToField;
